<template>
  <a href="javascript:;" @click.prevent="send" :class="{disabled: second > 0}">{{text}}</a>
</template>

<script>

export default {
  name: 'Sms',
  props: ['mobile'],
  data () {
    return {
      second: 0,
      text: '发送验证码'
    }
  },
  methods: {
    send() {
      var self = this;
      var i = 0;

      var patrn = /^(1|01)\d{10}$/;

      this.$message.closeAll()
      if (!this.mobile) {
        return this.$message.error('请填写您的手机号码')
      }
      if (!patrn.test(this.mobile)) {
        return this.$message.error('请填写正确的手机号码')
			}

      if (!this.second) {
        this.second = 60;
        this.text = '已发送 ('+this.second+')';
        var query = { params: {m: this.mobile} };
        this.axios.get(this.axios.apiGateway + "sms/send", query)
        .then(res => {
          if (res.data.errcode) {
            this.$message.error(res.data.errmsg)
          } else {
            this.$message.success("验证码已发送")
          }
        })

        var interval = setInterval(function() {
          self.second --;
          self.text = '已发送 ('+self.second+')';
          if (self.second <= 0) {
            self.text = '重新发送';
            clearInterval(interval);
          }
        }, 1000);
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .disabled {
    pointer-events: none;
    opacity: .5;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sms.vue